export default __webpack_public_path__ + "media/builders/preview-arrow-34fc84ba.png";